import { useLocation, useNavigate } from "react-router-dom";
import { ZERO } from "utils/constants";

export const useUpdateQueryParams = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (newParams: Record<string, string | null>) => {
    const searchParams = new URLSearchParams(); // Start fresh

    if (Object.keys(newParams).length === ZERO) {
      // If an empty object is passed, remove all query parameters
      navigate(location.pathname, { replace: true });
      return;
    }

    // Add only new query parameters
    Object.keys(newParams).forEach((key) => {
      if (newParams[key] !== null && newParams[key] !== undefined) {
        searchParams.set(key, newParams[key]);
      }
    });

    // Update the URL without reloading the page
    navigate(
      {
        pathname: location.pathname,
        search: `?${searchParams.toString()}`,
      },
      { replace: true }
    );
  };
};
